function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { dasherize } from '@ember/string';
import { pluralize } from 'ember-inflector';
import { jsonPost } from '@square/dashboard-utilities/utils/xhr';
import BaseChannel from '@square/dashboard-data/adapters/channels/base-channel';
export default class SurveyResponse extends BaseChannel {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "namespace", 'api/v1');
  }
  pathForType(type) {
    return pluralize(dasherize(type));
  }

  // @ts-expect-error [can] not sure how to type this
  createRecord(store, type, snapshot) {
    const url = this.buildURL(type.modelName, null, snapshot, 'createRecord');
    const payload = snapshot.record.serialize();
    return jsonPost(url, {
      payload
    });
  }
}